import React from 'react'
import "./Weather.css"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import axios from "axios";
import { useEffect,useState} from "react";
export default function Weather() {
    const [search, setsearch] = useState("karachi")
    const [state, setstate] = useState()
useEffect(()=>{
    axios(`https://api.openweathermap.org/data/2.5/weather?q=${search}&units=metric&appid=e66647ae648e6ad4ad5398eab811dbe3`)
    // .then(response => response.json())
    .then((data)=>{
        console.log('data:',data)
        // console.log('data:',data.data.main.temp)
        setstate(data.data)
        // seticon(data.data)
        // setstate(data)
        // console.log(state)
      })
 .catch((data)=>{
   console.log(data)
 })
    // .then(data => console.log(data));

},[search])

    return (
        <div>
            
            <div className="flex">
             <div className="main_div">
             <div className="input-group flex-nowrap">
                <input onChange={(event)=>{setsearch(event.target.value)}} type="text" className="form-control" placeholder="Search Your City" aria-label="Username" aria-describedby="addon-wrapping" />
             </div>
               
            
             {!state? (
              <p></p>
             ) : (
                 <>
                <img width={200} alt="" src={`http://openweathermap.org/img/wn/${state.weather[0].icon}@2x.png`} />
                <h1>{search},{state.sys.country}</h1> <br />
                <h2>{state.main.temp}<sup>o</sup>Cel </h2> <br />
                <h3>{state.weather[0].main}</h3>
               <div style={{float:'left',marginLeft:"50px"}}>
                <p  style={{color:'red ',fontWeight:'bold',textDecoration:"underline",fontSize:"20px"}}>Humidity</p>
                <p>{state.main.humidity}</p>
                </div>

                <div style={{float:'right',marginRight:"50px"}}>
                <p style={{color:'red ',fontWeight:'bold',textDecoration:"underline",fontSize:"20px"}}>Min/Max</p>
                <p>{state.main.temp_max}/{state.main.temp_min}</p>
                </div>
                </>
              )}
           
             </div>
             </div>
         </div>
    )
}
